import HeaderDashboard from '../../Components/HeaderDashboard'
import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FlightBookingDetails } from "../../Services/API"

const TransactionDetails = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("referenceNo");
  //const trackId = queryParams.get("trackID");

  const [flightDetails, setFlightDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (referenceNo) {
      fetchFlightBookingDetails(referenceNo);
    } else {
      console.warn("Missing referenceNo and trackId");
    }
  }, [referenceNo]);

  const fetchFlightBookingDetails = async (referenceNo) => {
    try {
      setLoading(true);
      setError("");
      const params = { ReferenceNo: referenceNo, TrackID: "", ClientCode: "BerryJourneys", Key: "", SessionID: "" };
      const response = await FlightBookingDetails(params);
      setFlightDetails(response);
      console.log(response.status)
      debugger;
    } catch (err) {
      setError("Failed to load flight Booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <HeaderDashboard></HeaderDashboard>
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Flight</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Reservations/Flight/AllTransactions" className="text-muted text-hover-primary">All Transactions</a>
                </li>

                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Reservations/Flight/AllTransactions" className="breadcrumb-item text-gray-900">Transaction Details</a>
                </li>

              </ul>
            </div>
          </div>

        </div>
      </div>
      <section className='wraper'>
        <div className='box_shadow mt-14'>
          {/* flightDetails.status ==="Confirmed" && */}

          {flightDetails && flightDetails.airBookingResponse.length > 0 ? (
            <>
              <div class="row mamage_depo">
                <div class="col-lg-6">
                  <h6 className='ruler'>Flight Booking Details</h6>
                </div>
                {flightDetails.airBookingResponse[0].bookingStatus === "Confirmed" && (
                  <div class="col-lg-6 text-right">
                    <ul className='option_s'>
                      <li> <a href="/reservations/flight/PrintInvoice" target='_blank'><img src="/assets/images/printer.png" alt="" /></a></li>
                      <li><a href="/reservations/flight/CancellationBooking"><img src="/assets/images/ticket.png" alt="" /></a></li>
                      <li><a href="/reservations/flight/customerinvoice"><img src="/assets/images/Invoice.png" alt="" /> </a></li>
                      <li><a href="/reservations/flight/agencyinvoice"><img src="/assets/images/Invoice.png" alt="" /></a></li>
                      <li><a href="/reservations/flight/ReSchedule?referenceNo="><img src="/assets/images/ticket.png" alt="" /> </a></li>
                      <li><a href="/"><img src="/assets/images/Download.png" alt="" /></a></li>
                    </ul>
                    {/* <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn btn-primary btn-sm"
        onClick={() => setOpen(!open)}
      >
        Dropdown <i className="fa fa-caret-down"></i>
      </button>

      {open && (
        <div className="dropdown-content">
          <a href="/reservations/flight/PrintInvoice" target='_blank'><img src="/assets/images/printer.png" alt="" /> Print Ticket</a>
          <a href="/reservations/flight/CancellationBooking"><img src="/assets/images/ticket.png" alt="" /> Cancel Ticket</a>
          <a href="/reservations/flight/customerinvoice"><img src="/assets/images/Invoice.png" alt="" /> Customer Invoice</a>
          <a href="/reservations/flight/agencyinvoice"><img src="/assets/images/Invoice.png" alt="" /> Agency Invoice</a>
          <a href="/reservations/flight/ReSchedule?referenceNo="><img src="/assets/images/ticket.png" alt="" /> Re-Schedule</a>
          <a href="/"><img src="/assets/images/Download.png" alt="" /> Download Ticket</a>
        </div>
      )}
    </div> */}

                  </div>
                )}
              </div>
              <div className='col-md-12 col-lg-12'>

                <div className='table-responsive'>
                  <table className='table table-bordered'>
                    <thead>
                      <tr>
                        <th>Reference No</th>
                        <th>Confirmation Number (PNR)</th>
                        <th>Booking Status</th>
                        <th>Ticketing Status</th>
                        <th>Booking Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{flightDetails.referenceNo}</td>
                        <td>{flightDetails.airBookingResponse[0].pnr}</td>
                        <td>{flightDetails.airBookingResponse[0].bookingStatus}</td>
                        <td>{flightDetails.airBookingResponse[0].ticketingStatus}</td>
                        <td>{flightDetails.airBookingResponse[0].bookingDate}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Travel Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Travel Date</th>
                        <th>Flight No.</th>
                        <th>Aircraft Type</th>
                        <th>From / Terminal </th>
                        <th>To / Terminal</th>
                        <th>Dep Time</th>
                        <th>Arr Time</th>
                        <th>Airline</th>
                      </tr>
                      {flightDetails?.airBookingResponse?.map((bookingResponse, bookingIndex) => (
                        bookingResponse?.flightDetails?.map((flight, flightIndex) => (
                          <tr key={`${bookingIndex}-${flightIndex}`}>
                            <td>
                              {new Date(flight.departDateTime).toLocaleDateString("en-US", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric"
                              }).replace(",", " ,")}
                            </td>
                            {/* <td>{flight.DepartDateTime}</td> */}
                            <td>{flight.airLineCode} - {flight.flightNumber}</td>
                            <td><samp>N/A</samp></td>
                            <td class="dropdown-caps">{flight.departAirportCode} / {flight.departTerminal}</td>
                            <td class="dropdown-caps">{flight.arrivalAirportCode} / {flight.arrivalTerminal}</td>
                            <td>
                              {new Date(flight.departDateTime).toLocaleString("en-GB", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </td>

                            <td>
                              {new Date(flight.arrivalDateTime).toLocaleString("en-GB", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </td>
                            <td>{flight.airLineName}</td>
                          </tr>
                        ))
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Contact Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Preferred Mobile No</th>
                        <th>Email address </th>
                      </tr>
                      <tr valign="top">
                        <td>
                          <div id="phone">
                            {flightDetails.airBookingResponse[0].customerInfo.mobileCountryCode} {flightDetails.airBookingResponse[0].customerInfo.mobile}
                          </div>
                        </td>
                        <td>
                          <div id="phone">{flightDetails.airBookingResponse[0].customerInfo.email}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Passenger Information</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered hide--mobile">
                    <tbody>
                      <tr>
                        <th>S.No</th>
                        <th>Passenger Name</th>
                        <th>Pax Type</th>
                        <th>Date of Birth</th>
                      </tr>
                      {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerDetails?.map((pax, index) => (
                        <tr key={index} valign="top">
                          <td>{index + 1}.</td>
                          <td style={{ textTransform: "uppercase" }}>
                            {pax.title}. {pax.firstName} {pax.lastName}
                          </td>
                          <td style={{ textTransform: "uppercase" }}>
                            {pax.paxType?.toUpperCase().trim() === "ADT" && "ADULT"}
                            {pax.paxType?.toUpperCase().trim() === "CHD" && "CHILD"}
                            {pax.paxType?.toUpperCase().trim() === "INF" && "INFANT"}
                          </td>
                          <td>
                            {pax.dateOfBirth
                              ? new Date(pax.dateOfBirth).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              : pax.dateOfBirth}
                          </td>

                          {/* Uncomment if needed */}
                          {/* <td>{pax.PassportNumber}</td> */}
                        </tr>
                      ))}


                    </tbody>
                  </table>
                </div>
              </div>
              {flightDetails.airBookingResponse[0].customerInfo.passengerTicketDetails != null && flightDetails.airBookingResponse[0].customerInfo.passengerTicketDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Ticket Information</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th width="15">S.No</th>
                          <th>Passenger Name</th>
                          <th>ETicket-No</th>
                          <th>Status</th>
                        </tr>

                        {flightDetails?.airBookingResponse[0]?.customerInfo?.passengerTicketDetails?.map((pax, index) => (
                          <tr key={index} valign="top">
                            <td>{index + 1}.</td>
                            <td style={{ textTransform: "uppercase" }}>
                              {pax.title}. {pax.firstName} {pax.lastName}
                            </td>
                            <td>{pax.ticketNumber}</td>
                            <td>Ticketed</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div className='col-md-12 col-lg-12'>
                <h6 className='ruler'>Payment Information(Fare Details)</h6>
                <div className='table-responsive'>
                  <table class="table table-bordered hide--mobile">
                    <tbody><tr>
                      <th>Total Fare</th>
                      <th>Base Fare</th>
                      <th>Taxes</th>
                      <th>Aff Comm %</th>
                      <th>AffComm Amt</th>
                      <th>GSTon AffComm Amt</th>
                      <th>NetAff Comm Amt</th>
                      <th>TdsOn Commission</th>
                      <th>Amount Payable</th>
                    </tr>
                      {flightDetails.airBookingResponse.map((pay, index) => (
                        <tr key={index}>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>5800</td>
                          <td>4525</td>
                          <td>0</td>
                          <td>0%</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={3}>
                          <span>
                            Total Price:
                          </span>
                          <span><b><i class="fa fa-inr" aria-hidden="true"></i> 842.00</b></span>
                        </td>
                        <td colSpan={3}>
                          <span>
                            SSR Amount:
                          </span>
                          <span><b><i class="fa fa-inr" aria-hidden="true"></i> 0.00</b></span>
                        </td>
                        <td colSpan={3}>
                          <span>
                            Grand Total Fare:
                          </span>
                          <span><i class="fa fa-inr" aria-hidden="true"></i> 842.00</span>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <span>
                            Class Of Service:
                          </span>
                          <span><b></b></span>
                        </td>
                        <td colSpan={3}>
                          <span>
                            RBD:
                          </span>
                          <span><b></b></span>
                        </td>
                        <td colSpan={3}>
                          <span>
                            Fare Basis Code:
                          </span>
                          <span><b></b></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {flightDetails.airBookingResponse[0].sSRDetails != null && flightDetails.airBookingResponse[0].sSRDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Baggage Details</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              Pax :
                            </span>
                            <span><b> ADT</b></span>
                          </td>
                          <td>
                            <span>
                              Sector :
                            </span>
                            <span><b> DXB - DBR</b></span>
                          </td>
                          <td>
                            <span>
                              Baggage :
                            </span>
                            <span><b> 30 Kg</b></span>
                          </td>
                          <td>
                            <span>
                              Cabin Baggage :
                            </span>
                            <span><b> 07 Kg</b></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {flightDetails.paymentDetails != null && flightDetails.paymentDetails.length > 0 && (
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Transaction Summary</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>Payment Status</th>
                          <th>Amount Paid</th>
                          <th>Created On</th>
                        </tr>
                        <tr>
                          <td>{flightDetails.paymentDetails[0].paymentStatus}</td>
                          <td><i class="fa fa-inr" aria-hidden="true"></i> {flightDetails.paymentDetails[0].amountPaid}</td>
                          <td>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div class="col-lg-12 important_info">
                <h4>IMPORTANT INFORMATION</h4>
                <ul>
                  <li>You must web check-in on the airline website and obtain a boarding pass.</li>
                  <li>It is mandatory to wear a mask and carry other protective gear.</li>
                  <li>
                    Reach the terminal at least 2 hours prior to the departure for domestic flight and 4 hours prior to the departure of international flight.
                  </li>
                  <li>For departure terminal please check with the airline first.</li>
                  <li>Date &amp; Time is calculated based on the local time of the city/destination.</li>
                  <li>Use the Airline PNR for all Correspondence directly with the Airline</li>
                  <li>For rescheduling/cancellation within 4 hours of the departure time contact the airline directly</li>
                  <li>
                    Your ability to travel is at the sole discretion of the airport authorities and we shall not be held responsible.
                  </li>

                </ul>
              </div>
            </>
          ) : (
            <>
              <div class="row mamage_depo">
                <div class="col-lg-12">
                  <h6 className='ruler'>Flight Booking Details</h6>
                </div>
                <div class="col-lg-12">
                  <p className=''>No Flight Booking Details Found !!</p>
                </div>
              </div>
            </>
          )
          }
        </div>
      </section>

    </>
  );
};

export default TransactionDetails;